module.exports = __webpack_public_path__ + "statics/img/service_bg.png";